import { SearchResultsView } from "@/components/search/SearchResultsView";
import { InitialSearchView } from "../InitialSearchView";
import { useCallback } from "react";
import { mainBus } from "@/common/buses";
import "./SearchPopup.scss";

interface ISearchPopupProps {
  searchValue: string;
}

export const SearchPopup = ({ searchValue }: ISearchPopupProps) => {
  const onCloseSearch = useCallback(() => {
    mainBus.emit("close_search");
  }, []);

  return (
    <>
      <div className="searchPopup">
        {!searchValue ? <InitialSearchView /> : <SearchResultsView searchValue={searchValue} />}
      </div>
      <div className="searchPopupOverlay" onClick={onCloseSearch} />
    </>
  );
};
